module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[63]184.b622b94.woff2";